<template>
    <div>
        <omni-chat-internal></omni-chat-internal>
    </div>
</template>
 
<script>
</script>